import {
  index,
  integer,
  jsonb,
  pgTable,
  text,
  timestamp,
  uuid,
} from "drizzle-orm/pg-core";
import { sql } from "drizzle-orm";

const tz = { withTimezone: true } as const;

export const STATUS_PAGE_SERVICES = [
  "api",
  "auth",
  "email",
  "pages",
  "webhooks",
  "analytics",
] as const;

export type StatusPageService = (typeof STATUS_PAGE_SERVICES)[number];

export const STATUS_PAGE_SERVICE_STATES = [
  "operational",
  "degraded",
  "major_outage",
] as const;

export type StatusPageServiceState = (typeof STATUS_PAGE_SERVICE_STATES)[number];

export interface PlatformIncidentUpdate {
  id: string;
  status: PlatformIncidentStatus;
  message: string;
  createdAt: string;
}

export const PLATFORM_INCIDENT_STATUSES = [
  "investigating",
  "identified",
  "monitoring",
  "resolved",
] as const;

export type PlatformIncidentStatus = (typeof PLATFORM_INCIDENT_STATUSES)[number];

export const serviceStatusHistory = pgTable("service_status_history", {
  id: uuid("id").primaryKey().defaultRandom(),
  service: text("service").$type<StatusPageService>().notNull(),
  status: text("status").$type<StatusPageServiceState>().notNull(),
  responseTimeMs: integer("response_time_ms"),
  httpStatus: integer("http_status"),
  errorMessage: text("error_message"),
  checkedAt: timestamp("checked_at", tz).notNull().defaultNow(),
  createdAt: timestamp("created_at", tz).notNull().defaultNow(),
}, (table) => [
  index("idx_service_status_history_service_checked").on(table.service, table.checkedAt),
  index("idx_service_status_history_checked").on(table.checkedAt),
]);

export const platformIncidents = pgTable("platform_incidents", {
  id: uuid("id").primaryKey().defaultRandom(),
  title: text("title").notNull(),
  status: text("status").$type<PlatformIncidentStatus>().notNull().default("investigating"),
  summary: text("summary").notNull(),
  affectedServices: jsonb("affected_services")
    .$type<StatusPageService[]>()
    .notNull()
    .default(sql`'[]'::jsonb`),
  updates: jsonb("updates")
    .$type<PlatformIncidentUpdate[]>()
    .notNull()
    .default(sql`'[]'::jsonb`),
  createdByUserId: text("created_by_user_id").notNull(),
  resolvedAt: timestamp("resolved_at", tz),
  createdAt: timestamp("created_at", tz).notNull().defaultNow(),
  updatedAt: timestamp("updated_at", tz).notNull().defaultNow(),
}, (table) => [
  index("idx_platform_incidents_status_created").on(table.status, table.createdAt),
  index("idx_platform_incidents_updated").on(table.updatedAt),
]);
